import { Box, Card, CardHeader } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';

import { ChargingVehicleList, Loading } from "components/common";
import GemDrawerMenu from "components/common/DrawerMenu";

import { useAuth0 } from "@auth0/auth0-react";
import auth_config from "auth_config.json";
import { useUser } from "contexts";
import { GraphQLClient } from "graphql-request";
import { depot_charging_query } from "queries";

const endpoint = process.env.REACT_APP_GEMINI_URL || "http://localhost:4000/graphql";


function formatDepot(depot) {
  // console.log("formatDepot", depot);
  const evs = depot.vehicles.filter(vehicle => (vehicle.isElectric && vehicle.displayName != null));

  return {
    depot: depot,
    name: depot.name,
    geofence: depot.geofence,
    charge_points: depot.chargePoints,
    total_power: depot.totalPower,
    vehicles: evs,
    charging: evs.filter(vehicle => depot.chargePoints.map(cp => cp.chargePointConnectors.filter(cpc => cpc.connectedVehicle !== null).length).reduce((p, c) => p + c, 0)).length,
    in_service: evs.filter(vehicle => vehicle.depotState === "outside_depot").length,
    in_depot: evs.filter(vehicle => vehicle.depotState === "within_depot").length,
  }
}
function timeout(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function fetch(query, auth_token, query_options = {}) {
  const ac = new AbortController();
  const client = new GraphQLClient(endpoint, 
    { headers: { "Authorization": `Bearer ${auth_token}` }, 
    signal: ac.signal,
    method: 'GET'
  });

  const result = await Promise.race([
    client.request(query, query_options), timeout(40000).then(async () => { ac.abort("Timeout?"); return "timeout"; })
  ]);

  if (result === "timeout") throw new Error("Request Timed Out");
  return result;
}



function ChargingPage() {
  let { id } = useParams()

  const { logout, getAccessTokenSilently, error: auth0_error, user: auth0_user, isLoading } = useAuth0();
  const { context: user_context, register_user } = useUser();
  const { user } = user_context;
  const [depot, setDepot] = useState(null);

  let depot_error = null;

  useEffect(() => {
    const fetchDepot = async () => {
      try{
        setDepot(null);               // Set null, so when changing between e.g. Randwick and Waverly, it shows "Loading..."
        const accessToken = await getAccessTokenSilently({
          audience: auth_config.audience,
          scope: auth_config.scope,
        });
        const data = await fetch(depot_charging_query, accessToken, { depot: id });
        setDepot(formatDepot(data.depot));
      } catch(e) {
        console.error("Error fetching depot charging data", e);
        depot_error = e;
      }
    };
    fetchDepot();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    register_user();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (depot_error != null) {
    console.error("depot_error", depot_error);
    return null;
  }

  return (
    <Box display="flex" width="100%">
      <GemDrawerMenu />
      <Box sx={{ flexGrow: 1, padding: '5px' }}>
        <Card>
          <Box sx={{ backgroundColor: '#07A0C3', width: '100%', padding: '0px' }}>
            <CardHeader title={`Electric Vehicles`} sx={{ height: '60px' }} />
          </Box>
          {depot ? (
            <ChargingVehicleList vehicles={depot.vehicles} charge_points={depot.charge_points} />
          ) : (
            <Loading />
          )}
        </Card>
      </Box>
    </Box>
  );
}

export { ChargingPage };

